/**
 * DepositInfoSection Component
 * 협력사 입금 정보 조회 섹션 (읽기 전용)
 */
import React from 'react';
import { SupplierInfo } from '../types/supplierInfo.types';

interface DepositInfoSectionProps {
    supplierInfo: SupplierInfo;
}

const DepositInfoSection: React.FC<DepositInfoSectionProps> = ({
    supplierInfo
}) => {
    return (
        <div className="supplier-section">
            <h2 className="section-title">입금 정보</h2>
            <div className="supplier-form-grid">
                {/* 은행명 */}
                <div className="form-group">
                    <label className="form-label">은행명:</label>
                    <div className="form-input" style={{ 
                        backgroundColor: '#f5f5f5', 
                        border: '1px solid #ddd',
                        padding: '0.5rem',
                        minHeight: '38px',
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        {supplierInfo.dpBankName || '-'}
                    </div>
                </div>

                {/* 계좌번호 */}
                <div className="form-group">
                    <label className="form-label">계좌번호:</label>
                    <div className="form-input" style={{ 
                        backgroundColor: '#f5f5f5', 
                        border: '1px solid #ddd',
                        padding: '0.5rem',
                        minHeight: '38px',
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        {supplierInfo.dpAccountNumber || '-'}
                    </div>
                </div>

                {/* 예금주 */}
                <div className="form-group">
                    <label className="form-label">예금주:</label>
                    <div className="form-input" style={{ 
                        backgroundColor: '#f5f5f5', 
                        border: '1px solid #ddd',
                        padding: '0.5rem',
                        minHeight: '38px',
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        {supplierInfo.dpAccountName || '-'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DepositInfoSection;

